import { artistSections, artistPath } from '../../features/browse/artist';
import { albumGenre } from '../review/components/album/albumIntroPresentation';
export function normalizeArtistView(value) {
  if (value === 'albums') return 'full-albums';
  if (value === 'appears-on') return 'appears-on-albums';
  return artistSections.some(([, key]) => key === value) ? value : 'full-albums';
}
// Similar-artist DTO id is the provider ID; artistId is the persisted ID.
export function normalizeSimilarArtist(item) {
  return item.sourceId != null
    ? item
    : {
        ...item,
        id: item.artistId,
        sourceId: item.id,
        imageUrl: item.artistImageUrl,
      };
}
export function similarArtistPath(item) {
  const artist = normalizeSimilarArtist(item);
  return artistPath({ ...artist, slug: artist.id != null ? artist.slug : undefined });
}
export function artistAlbumPath(item) {
  if (item.slug)
    return `/reviews/${encodeURIComponent(item.slug)}?${new URLSearchParams({ source_id: item.sourceId })}`;
  return `/reviews/${String(item.albumSource || 'APPLE_MUSIC').toLowerCase()}/${encodeURIComponent(item.sourceId)}`;
}
export function artistAlbumMetadata(item, locale) {
  return [
    item.releaseDate?.slice(0, 4),
    (item.genreNames ?? item.genres ?? [])
      .slice(0, 2)
      .map((g) => albumGenre(g, locale))
      .join(', '),
  ]
    .filter(Boolean)
    .join(' · ');
}
export function artistCategoryTitle(name, view, locale) {
  const category = artistSections.find(([, key]) => key === view);
  if (view === 'similar-artists')
    return locale === 'en' ? `Artists Similar to ${name}` : `${name}와 유사한 아티스트`;
  return locale === 'en' ? `${name} · ${category[3]}` : `${name}의 ${category[2]}`;
}
export function artistSharePath(artist) {
  const slug = artist?.slug?.trim();
  if (
    artist?.id > 0 &&
    slug &&
    slug.length <= 500 &&
    !/^\.{1,2}$/.test(slug) &&
    // Reject control characters in externally shared paths.
    // eslint-disable-next-line no-control-regex
    !/[/\\?#\u0000-\u001f]/.test(slug)
  )
    return `/artists/${encodeURIComponent(slug)}`;
  const source = artist?.artistSource?.toLowerCase(),
    id = artist?.sourceId?.trim();
  if (
    ['apple_music', 'spotify', 'postpop'].includes(source) &&
    id &&
    id.length <= 255 &&
    !/^(unknown|null|undefined|\.{1,2})$/i.test(id) &&
    // eslint-disable-next-line no-control-regex -- reject control characters in provider IDs
    !/[\s/?#\\\u0000-\u001f]/.test(id)
  )
    return `/artists/${source}/${encodeURIComponent(id)}`;
  return null;
}
export function playlistArtworkData(item, detail) {
  return {
    ...item,
    imageUrl: item.imageUrl?.trim() || detail?.imageUrl?.trim(),
    previewImageUrls: item.previewImageUrls?.filter(Boolean).length
      ? item.previewImageUrls
      : [...(detail?.albums || []), ...(detail?.tracks || [])]
          .sort((a, b) => a.position - b.position)
          .map((x) => x.albumImageUrl)
          .filter(Boolean),
  };
}
